<template>
  <div>
      <div class="container [ pt-5 pb-4 ] [ text-center ]">
          <h1 class="heading">OPS</h1>
          <p>
              Qualcosa è andato storto
          </p>
          
      </div>
      <div class="container">
    <div class="text-center [ pt-4 pb-5 ]">
       
    </div>
</div>
  </div>
</template>

<script>
export default {
  name: "ViewError"
};
</script>

